import { Alert } from '@mui/material';
import { WizardButtons } from '../../Wizard/WizardButtons';

export const EndCall = (props) => {
  const handleEndCallFinish = () => {
    props.setClickOnDocu(false);
    props.completedHandler();
  };
  const renderText = () => {
    if (props.clickOnDocu)
      return 'Your correspondence has been sent via Docusign. Please check your email to complete and sign.';
    else return 'Please contact Policy Holder Services to complete your request.';
  };
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '10px',
        }}
      >
        <div style={{ marginTop: '10px', marginBottom: '10px' }}>
          <Alert severity="success">{renderText()}</Alert>
        </div>
        <WizardButtons {...props} completedHandler={handleEndCallFinish} nextText="End call" />
      </div>
    </div>
  );
};
